import { useJsApiLoader } from "@react-google-maps/api";
import UserComponent from "./user";

const UserTabWrapper = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["cities"],
  });

  if (loadError) return <div>Error loading Google Maps</div>;
  if (!isLoaded) return <div>Loading Google Maps...</div>;

  return <UserComponent />;
};

export default UserTabWrapper;
